/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React from "react";
import get from "lodash/get";
import { WithPreview } from "@quintype/components";
import { object } from "prop-types";

import ProjectStory from "../story-templates/projects-story";
import PublicationStory from "../story-templates/publication-story";

export function StoryPageBase({ story, collections, params, linkedStories, preview = false }, config) {
  // Can switch to a different template based story-template, or only show a spoiler if index > 0
  const storyTemplate = get(story, ["story-template"], "");

  if (storyTemplate === "project") {
    return (
      <ProjectStory
        story={story}
        collections={collections}
        cardId={get(params, ["cardId"])}
        linkedStories={linkedStories}
        config={config}
        preview={preview}
      />
    );
  } else if (storyTemplate === "publication") {
    return (
      <PublicationStory
        story={story}
        collections={collections}
        cardId={get(params, ["cardId"])}
        config={config}
        preview={preview}
      />
    );
  } else {
    return (
      <ProjectStory
        story={story}
        collections={collections}
        cardId={get(params, ["cardId"])}
        isBlog={true}
        config={config}
        preview={preview}
      />
    );
  }
}

StoryPageBase.propTypes = {
  story: object,
  config: object
};

export function StoryPage(props) {
  return <StoryPageBase {...props.data} />;
}

StoryPage.propTypes = {
  data: object
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story
  })
);
